import { createSelector } from 'reselect';

export function getChart(state) {
  return state.chart;
}


// WEBPACK FOOTER //
// ./src/core/chart/selectors.js